import { FreeRoundBonus } from "../Bonuses/FreeRoundBonus";
import { DataManager } from "../../../Managers/DataManager";
import { GameData } from "../Datas/GameData";
import { PlayList } from "../../../Components/Sounds/PlayList";
import { AppContext } from "../../../../Common/AppContext";
import { UriHelper } from "neo-common";
import { Platforms } from "neo-games";
import { RetentionPanel } from "../../../Utils/RetentionPanel";
import { BetHigherThanMinDialog } from "./BetHigherThanMinDialog";

export class FreeRoundBonusDialog {
    private static Dialog: HTMLElement;
    private static DialogContentOther: HTMLElement;
    private static DialogContentOther2: HTMLElement;
    private static DialogContentOtherList: HTMLElement;
    private static DialogContentOtherList2: HTMLElement;
    private static DialogContentNew: HTMLElement;
    private static DialogContentActive: HTMLElement;
    private static DialogContentEnd: HTMLElement;
    private static DialogContentExpired: HTMLElement;
    private static ConfirmationDialog: HTMLElement;
    private static DialogButtonPlay: HTMLElement;
    private static DialogButtonPostPone: HTMLElement;
    private static DialogButtonDeny: HTMLElement;
    private static DialogButtonOk: HTMLElement;
    private static DialogButtonYes: HTMLElement;
    private static DialogButtonNo: HTMLElement;

    private static otherOffersKeys: Array<string> = [];
    private static otherHasBuyFeatureKeys: Array<boolean> = [];
    private static dialogOtherGamesMessage: DialogOtherGamesMessageValue;

    private static isConfirmationDialogOpened: boolean = false;

    public static initialize(): void {
        FreeRoundBonusDialog.Dialog = document.getElementById("frbDialog");
        FreeRoundBonusDialog.DialogContentOther = document.getElementById("frbDialogContentOther");
        FreeRoundBonusDialog.DialogContentOther2 = document.getElementById("frbDialogContentOther2");
        FreeRoundBonusDialog.DialogContentOtherList = document.getElementById("frbDialogContentOtherList");
        FreeRoundBonusDialog.DialogContentOtherList2 = document.getElementById("frbDialogContentOtherList2");
        FreeRoundBonusDialog.DialogContentNew = document.getElementById("frbDialogContentNew");
        FreeRoundBonusDialog.DialogContentActive = document.getElementById("frbDialogContentActive");
        FreeRoundBonusDialog.DialogContentEnd = document.getElementById("frbDialogContentEnd");
        FreeRoundBonusDialog.DialogContentExpired = document.getElementById("frbDialogContentExpired");
        FreeRoundBonusDialog.ConfirmationDialog = document.getElementById("frbConfirmationDialog");
        FreeRoundBonusDialog.DialogButtonPlay = document.getElementById("dialogBtnPlay");
        FreeRoundBonusDialog.DialogButtonPostPone = document.getElementById("dialogBtnPostPone");
        FreeRoundBonusDialog.DialogButtonDeny = document.getElementById("dialogBtnDeny");
        FreeRoundBonusDialog.DialogButtonOk = document.getElementById("dialogBtnOk");
        FreeRoundBonusDialog.DialogButtonYes = document.getElementById("dialogBtnYes");
        FreeRoundBonusDialog.DialogButtonNo = document.getElementById("dialogBtnNo");
        FreeRoundBonusDialog.bindEvents();

        FreeRoundBonusDialog.setupFRBDialogByConfiguration();
    }

    // new, other, active, end
    public static showDialog(type: string): void {
        DataManager.updateGameDataFromModule(GameData.DataFrbRemainginCount, FreeRoundBonus.remainingCount());
        DataManager.updateGameDataFromModule(GameData.DataFrbAssignedCount, FreeRoundBonus.assignedCount());
        DataManager.updateGameDataFromModule(GameData.DataFrbValidTo, FreeRoundBonus.valid());
        DataManager.updateGameDataFromModule(GameData.DataFrbWin, FreeRoundBonus.win());
        DataManager.updateDataElement(GameData.DataFrbRemainginCount, FreeRoundBonus.remainingCount());
        DataManager.updateDataElement(GameData.DataFrbAssignedCount, FreeRoundBonus.assignedCount());
        DataManager.updateDataElement(GameData.DataFrbValidTo, FreeRoundBonus.valid());
        DataManager.updateDataElement(GameData.DataFrbWin, FreeRoundBonus.win());
        FreeRoundBonusDialog.termsUrl();
        DataManager.showDataElements("frbRules", "");
        if (FreeRoundBonus.rulesLink() === "") {
            DataManager.hideDataElements("frbRules");
        }
        if (FreeRoundBonus.win() === "") {
            DataManager.hideDataElements("frbWin");
        } else {
            DataManager.showDataElements("frbWin");
        }
        FreeRoundBonusDialog.hideAllButtons();
        FreeRoundBonusDialog.hideAllContents();
        DataManager.hideDataElements("frbCumulative");
        DataManager.hideDataElements("frbPlatformTransactionFail");
        Platforms.Platforms.closeMenu();
        Platforms.Platforms.dialogOpened("frb", true);
        switch (type) {
            case "new":
                FreeRoundBonusDialog.Dialog.classList.remove("frbDialogType", "ffrDialogType");
                FreeRoundBonus.state = "new";
                FreeRoundBonusDialog.showElement(FreeRoundBonusDialog.DialogContentNew);
                FreeRoundBonusDialog.showElement(FreeRoundBonusDialog.DialogButtonPlay);
                FreeRoundBonusDialog.showElement(FreeRoundBonusDialog.DialogButtonPostPone);
                FreeRoundBonusDialog.showElement(FreeRoundBonusDialog.DialogButtonDeny);

                if (FreeRoundBonus.winPayMethod === "cumulative") {
                    DataManager.showDataElements("frbCumulative");
                }

                if (FreeRoundBonusDialog.isConfirmationDialogOpened) {
                    FreeRoundBonusDialog.showElement(FreeRoundBonusDialog.ConfirmationDialog);
                }

                break;
            case "other":
                FreeRoundBonusDialog.Dialog.classList.remove("frbDialogType", "ffrDialogType");
                FreeRoundBonus.state = "other";
                FreeRoundBonusDialog.refillOtherGames();
                if (
                    AppContext != null &&
                    AppContext.gameConfiguration != null &&
                    AppContext.gameConfiguration.ShowSimilarGames
                ) {
                    FreeRoundBonusDialog.showElement(FreeRoundBonusDialog.DialogContentOther);
                } else {
                    FreeRoundBonusDialog.showElement(FreeRoundBonusDialog.DialogContentOther2);
                }
                FreeRoundBonusDialog.showElement(FreeRoundBonusDialog.DialogButtonOk);
                FreeRoundBonus.openOther();
                break;
            case "active":
                FreeRoundBonus.state = "active";
                FreeRoundBonusDialog.showElement(FreeRoundBonusDialog.DialogContentActive);
                FreeRoundBonusDialog.showElement(FreeRoundBonusDialog.DialogButtonOk);
                if (FreeRoundBonus.winPayMethod === "cumulative") {
                    DataManager.showDataElements("frbCumulative");
                }
                break;
            case "end":
                FreeRoundBonus.state = "end";
                FreeRoundBonusDialog.showElement(FreeRoundBonusDialog.DialogContentEnd);
                FreeRoundBonusDialog.showElement(FreeRoundBonusDialog.DialogButtonOk);
                if (FreeRoundBonus.status === "pending" && FreeRoundBonus.totalWin > 0) {
                    DataManager.showDataElements("frbPlatformTransactionFail");
                }
                break;
            case "expired":
                FreeRoundBonus.state = "expired";
                FreeRoundBonusDialog.showElement(FreeRoundBonusDialog.DialogContentExpired);
                FreeRoundBonusDialog.showElement(FreeRoundBonusDialog.DialogButtonOk);
                break;
        }
        DataManager.hideDataElements("frbRegular");
        DataManager.hideDataElements("frbFeature");
        DataManager.hideDataElements("frbOptionsFrb");
        DataManager.hideDataElements("frbOptionsFfr");
        DataManager.hideDataElements("frbOptionsMixed");

        switch (FreeRoundBonusDialog.dialogOtherGamesMessage) {
            case DialogOtherGamesMessage.FRB:
                DataManager.showDataElements("frbOptionsFrb");
                break;
            case DialogOtherGamesMessage.FFR:
                DataManager.showDataElements("frbOptionsFfr");
                break;
            case DialogOtherGamesMessage.MIXED:
                DataManager.showDataElements("frbOptionsMixed");
                break;
        }

        if (FreeRoundBonus.dialogType !== DialogType.Other) {
            if (FreeRoundBonus.dialogType == DialogType.FFR) FreeRoundBonusDialog.Dialog.classList.add("ffrDialogType");
            if (FreeRoundBonus.dialogType == DialogType.FRB) FreeRoundBonusDialog.Dialog.classList.add("frbDialogType");
        }
        if (FreeRoundBonus.state === "new" || FreeRoundBonus.state === "active") {
            if (FreeRoundBonus.dialogType !== null && FreeRoundBonus.dialogType == DialogType.FFR) {
                if (FreeRoundBonus.remainingCount() === "1") {
                    DataManager.showDataElements("frbFeatureSingle");
                } else {
                    DataManager.showDataElements("frbFeatureMultiple");
                }
            } else {
                if (FreeRoundBonus.remainingCount() === "1") {
                    DataManager.showDataElements("frbRegularSingle");
                } else {
                    DataManager.showDataElements("frbRegularMultiple");
                }
            }
        }

        FreeRoundBonusDialog.showElement(FreeRoundBonusDialog.Dialog);
    }

    private static setConfirmationDialog(value: boolean): void {
        FreeRoundBonusDialog.isConfirmationDialogOpened = value;
    }

    private static setPointerEventsButtons(value: "" | "none" = ""): void {
        FreeRoundBonusDialog.DialogButtonPlay.style.pointerEvents = value;
        FreeRoundBonusDialog.DialogButtonPostPone.style.pointerEvents = value;
        FreeRoundBonusDialog.DialogButtonDeny.style.pointerEvents = value;
    }

    public static hideDialog(): void {
        Platforms.Platforms.dialogOpened("frb", false);
        FreeRoundBonusDialog.hideElement(FreeRoundBonusDialog.Dialog);
        FreeRoundBonusDialog.hideElement(FreeRoundBonusDialog.ConfirmationDialog);
    }

    private static bindEvents(): void {
        if (FreeRoundBonusDialog.DialogButtonPlay != null) {
            FreeRoundBonusDialog.DialogButtonPlay.onclick = FreeRoundBonusDialog.onPlay;
        }

        if (FreeRoundBonusDialog.DialogButtonPostPone != null) {
            FreeRoundBonusDialog.DialogButtonPostPone.onclick = FreeRoundBonusDialog.onPostPone;
        }

        if (FreeRoundBonusDialog.DialogButtonDeny != null) {
            FreeRoundBonusDialog.DialogButtonDeny.onclick = FreeRoundBonusDialog.onDeny;
        }

        if (FreeRoundBonusDialog.DialogButtonOk != null) {
            FreeRoundBonusDialog.DialogButtonOk.onclick = FreeRoundBonusDialog.onOk;
        }

        if (FreeRoundBonusDialog.DialogButtonYes != null) {
            FreeRoundBonusDialog.DialogButtonYes.onclick = FreeRoundBonusDialog.onYes;
        }

        if (FreeRoundBonusDialog.DialogButtonNo != null) {
            FreeRoundBonusDialog.DialogButtonNo.onclick = FreeRoundBonusDialog.onNo;
        }
    }

    private static hideAllButtons(): void {
        FreeRoundBonusDialog.hideElement(FreeRoundBonusDialog.DialogButtonPlay);
        FreeRoundBonusDialog.hideElement(FreeRoundBonusDialog.DialogButtonPostPone);
        FreeRoundBonusDialog.hideElement(FreeRoundBonusDialog.DialogButtonDeny);
        FreeRoundBonusDialog.hideElement(FreeRoundBonusDialog.DialogButtonOk);
    }

    private static hideAllContents(): void {
        FreeRoundBonusDialog.hideElement(FreeRoundBonusDialog.DialogContentActive);
        FreeRoundBonusDialog.hideElement(FreeRoundBonusDialog.DialogContentNew);
        FreeRoundBonusDialog.hideElement(FreeRoundBonusDialog.DialogContentOther);
        FreeRoundBonusDialog.hideElement(FreeRoundBonusDialog.DialogContentOther2);
        FreeRoundBonusDialog.hideElement(FreeRoundBonusDialog.DialogContentEnd);
        FreeRoundBonusDialog.hideElement(FreeRoundBonusDialog.DialogContentExpired);
        FreeRoundBonusDialog.hideElement(FreeRoundBonusDialog.ConfirmationDialog);
    }

    private static showElement(element: HTMLElement): void {
        if (element != null) {
            if (element.classList.contains("_disabled")) {
                element.classList.remove("_disabled");
            }
            if (element.classList.contains("_hidden")) {
                element.classList.remove("_hidden");
            }
        }
    }

    private static hideElement(element: HTMLElement): void {
        if (element != null) {
            if (element.classList.contains("_disabled")) {
                element.classList.remove("_disabled");
            }
            if (!element.classList.contains("_hidden")) {
                element.classList.add("_hidden");
            }
        }
    }

    private static disableElement(element: HTMLElement): void {
        if (element != null) {
            if (!element.classList.contains("_disabled")) {
                element.classList.add("_disabled");
            }
            if (element.classList.contains("_hidden")) {
                element.classList.remove("_hidden");
            }
        }
    }

    private static onPlay(): void {
        if (FreeRoundBonusDialog.isConfirmationDialogOpened) {
            return;
        }

        FreeRoundBonus.state = "";
        PlayList.play("SND_Click");
        FreeRoundBonusDialog.hideDialog();
        FreeRoundBonus.activateOffer();

        FreeRoundBonusDialog.setPointerEventsButtons("");
        RetentionPanel.revalidate();
    }

    private static onPostPone(): void {
        if (FreeRoundBonusDialog.isConfirmationDialogOpened) {
            return;
        }

        FreeRoundBonus.state = "";
        PlayList.play("SND_Click");
        FreeRoundBonusDialog.hideDialog();
        FreeRoundBonus.enableGame();

        FreeRoundBonusDialog.setPointerEventsButtons("");
        RetentionPanel.revalidate();

        BetHigherThanMinDialog.restoreDialog();
    }

    private static onDeny(): void {
        if (FreeRoundBonusDialog.isConfirmationDialogOpened) {
            return;
        }

        PlayList.play("SND_Click");
        FreeRoundBonusDialog.showElement(FreeRoundBonusDialog.ConfirmationDialog);

        FreeRoundBonusDialog.setConfirmationDialog(true);
        FreeRoundBonusDialog.setPointerEventsButtons("none");
        RetentionPanel.revalidate();

        BetHigherThanMinDialog.restoreDialog();
    }

    private static onYes(): void {
        FreeRoundBonus.state = "";
        PlayList.play("SND_Click");
        FreeRoundBonusDialog.hideDialog();
        FreeRoundBonus.declineOffer();

        FreeRoundBonusDialog.setConfirmationDialog(false);
        FreeRoundBonusDialog.setPointerEventsButtons("");
        RetentionPanel.revalidate();
    }

    private static onNo(): void {
        // FreeRoundBonus.state = ''; //we need to keep state, etc. when reality check dialog open
        PlayList.play("SND_Click");
        FreeRoundBonusDialog.hideElement(FreeRoundBonusDialog.ConfirmationDialog);

        FreeRoundBonusDialog.setConfirmationDialog(false);
        FreeRoundBonusDialog.setPointerEventsButtons("");
    }

    private static onOk(): void {
        FreeRoundBonus.state = "";
        PlayList.play("SND_Click");

        FreeRoundBonusDialog.hideDialog();

        if (FreeRoundBonus.isLastFrb) {
            FreeRoundBonus.finishFreeRounds();
        } else {
            FreeRoundBonus.enableGame();
        }

        FreeRoundBonusDialog.Dialog.classList.remove("frbDialogType", "ffrDialogType");

        RetentionPanel.revalidate();
    }

    public static revalidateOtherGames(): boolean {
        if (
            AppContext != null &&
            AppContext.gameConfiguration != null &&
            AppContext.gameConfiguration.StaticContentUrl === ""
        ) {
            return false;
        }

        FreeRoundBonusDialog.otherOffersKeys = [];
        FreeRoundBonusDialog.otherHasBuyFeatureKeys = [];

        let hasFrb = false;
        let hasFfr = false;

        if (FreeRoundBonus.otherOfferes.length > 0) {
            let now: number = new Date().getTime();
            for (let i: number = 0; i < FreeRoundBonus.otherOfferes.length; i++) {
                const offer = FreeRoundBonus.otherOfferes[i];
                if (offer["validTo"] != null) {
                    let countDownDate: number = new Date(offer["validTo"] + "+00:00").getTime();
                    let distance: number = countDownDate - now;

                    if (distance > 0 && offer["gameCode"] != null) {
                        FreeRoundBonusDialog.otherOffersKeys.push(offer["gameCode"]);
                    }

                    if (distance > 0 && offer["hasBuyFeature"] != null) {
                        const hasBuyFeature = offer["hasBuyFeature"];
                        FreeRoundBonusDialog.otherHasBuyFeatureKeys.push(hasBuyFeature);
                        if (hasBuyFeature) {
                            hasFfr = true;
                        } else {
                            hasFrb = true;
                        }
                    }
                }
            }
        }

        // Determine other dialog type
        if (hasFfr && hasFrb) {
            FreeRoundBonusDialog.dialogOtherGamesMessage =
                DialogOtherGamesMessage.MIXED as DialogOtherGamesMessageValue;
        } else if (hasFfr) {
            FreeRoundBonusDialog.dialogOtherGamesMessage = DialogOtherGamesMessage.FFR as DialogOtherGamesMessageValue;
        } else if (hasFrb) {
            FreeRoundBonusDialog.dialogOtherGamesMessage = DialogOtherGamesMessage.FRB as DialogOtherGamesMessageValue;
        }

        return FreeRoundBonusDialog.otherOffersKeys.length > 0;
    }

    public static refillOtherGames(): void {
        if (FreeRoundBonusDialog.DialogContentOtherList != null) {
            FreeRoundBonusDialog.DialogContentOtherList.innerHTML = "";
        }
        if (FreeRoundBonusDialog.DialogContentOtherList2 != null) {
            FreeRoundBonusDialog.DialogContentOtherList2.innerHTML = "";
        }
        for (let i: number = 0; i < 5; i++) {
            if (
                FreeRoundBonusDialog.otherOffersKeys.length > 0 &&
                FreeRoundBonusDialog.otherOffersKeys[i] != null &&
                FreeRoundBonusDialog.otherHasBuyFeatureKeys[i] != null
            ) {
                FreeRoundBonusDialog.createItem(
                    FreeRoundBonusDialog.otherOffersKeys[i],
                    false,
                    FreeRoundBonusDialog.otherHasBuyFeatureKeys[i],
                    FreeRoundBonusDialog.DialogContentOtherList,
                );
                FreeRoundBonusDialog.createItem(
                    FreeRoundBonusDialog.otherOffersKeys[i],
                    true,
                    FreeRoundBonusDialog.otherHasBuyFeatureKeys[i],
                    FreeRoundBonusDialog.DialogContentOtherList2,
                );
            }
        }
    }

    private static createItem(gameCode: string, noClick: boolean, hasBuyFeature: boolean, parent: HTMLElement): void {
        if (
            AppContext != null &&
            AppContext.gameConfiguration != null &&
            AppContext.gameConfiguration.StaticContentUrl === ""
        ) {
            return;
        }
        let itemHolder: HTMLDivElement = <HTMLDivElement>document.createElement("div");
        let itemLoading: HTMLDivElement = <HTMLDivElement>document.createElement("div");
        let itemLoadingIcon: HTMLDivElement = <HTMLDivElement>document.createElement("div");
        let itemLogo: HTMLDivElement = <HTMLDivElement>document.createElement("div");
        let itemFeatureType: HTMLDivElement = <HTMLDivElement>document.createElement("div");

        itemHolder.classList.add("frbOfferItem");
        itemLoading.classList.add("frbGameLoading");
        itemLoadingIcon.classList.add("loadingIcon");
        itemLogo.classList.add("frbGameLogo");
        itemFeatureType.classList.add("cssCommon", "flag");
        itemFeatureType.classList.add(hasBuyFeature ? "ffrFlag" : "frbFlag");
        itemLogo.setAttribute("game", gameCode);
        itemLogo.style.background =
            "url(" + AppContext.gameConfiguration.StaticContentUrl + gameCode + "/" + window["QUALITY"] + "/logo.jpg)";
        itemHolder.appendChild(itemLoading);
        itemLoading.appendChild(itemLoadingIcon);
        itemHolder.appendChild(itemLogo);
        itemHolder.appendChild(itemFeatureType);
        if (!noClick) {
            itemLogo.onclick = FreeRoundBonusDialog.selectGame;
        }

        if (parent != null) {
            parent.appendChild(itemHolder);
        }
    }

    private static selectGame(e: any): void {
        PlayList.play("SND_Click");
        if (e != null && e.target != null && e.target.hasAttribute("game")) {
            let urlInfo: Object = UriHelper.parseUrl(window.location.href, true, true);

            if (urlInfo != null && urlInfo["query"]["serverUrl"] && urlInfo["hash"]) {
                let serverUrl: string = urlInfo["query"]["serverUrl"];
                let token: string = urlInfo["hash"].substring(1);
                let newUrl: string = serverUrl + "Launch/" + e.target.getAttribute("game") + "?" + token;
                let root: HTMLElement = document.getElementById("root");
                if (root != null) {
                    root.style.display = "none";
                }

                Platforms.Platforms.gameChange(e.target.getAttribute("game"));
                if (Platforms.Platforms.handleChangeGame) {
                    return;
                }

                setTimeout(() => {
                    window.location.href = newUrl;
                }, 100);
            }
        }
    }

    private static termsUrl(): void {
        if (FreeRoundBonus.termsUrl != null && FreeRoundBonus.termsUrl !== "") {
            let elements: HTMLCollectionOf<Element> = document.getElementsByClassName("termsLink");
            for (let i: number = 0; i < elements.length; i++) {
                let element: HTMLElement = <HTMLElement>elements[i];
                if (element != null) {
                    element.setAttribute("href", FreeRoundBonus.termsUrl);

                    //fix to prevent Focus.onClick calling
                    element.addEventListener("click", function (e: Event) {
                        e.stopPropagation();
                    });
                }
            }
        }
    }

    private static setupFRBDialogByConfiguration(): void {
        if (AppContext.gameConfiguration) {
            if (!AppContext.gameConfiguration.FRBShowDenyButton) {
                FreeRoundBonusDialog.hideFRBDenyButton();
            }

            if (!AppContext.gameConfiguration.FRBShowPostponeButton) {
                FreeRoundBonusDialog.hideFRBPostPoneButton();
            }
        }
    }

    private static hideFRBDenyButton(): void {
        if (FreeRoundBonusDialog.DialogButtonDeny) {
            FreeRoundBonusDialog.DialogButtonDeny.parentNode.removeChild(FreeRoundBonusDialog.DialogButtonDeny);
        }

        //remove info text from message
        let infoMsg = document.getElementById("frbDialogPlayingOptions3");
        if (infoMsg) {
            infoMsg.parentNode.removeChild(infoMsg);
        }
    }

    private static hideFRBPostPoneButton(): void {
        if (FreeRoundBonusDialog.DialogButtonPostPone) {
            FreeRoundBonusDialog.DialogButtonPostPone.parentNode.removeChild(FreeRoundBonusDialog.DialogButtonPostPone);
        }

        //remove info text from message
        let infoMsg = document.getElementById("frbDialogPlayingOptions3");
        if (infoMsg) {
            infoMsg.parentNode.removeChild(infoMsg);
        }
    }

    public static dialogActive(): boolean {
        return !FreeRoundBonusDialog.Dialog.classList.contains("_hidden");
    }
}

export const DialogType = {
    FRB: "FRB",
    FFR: "FFR",
    Other: "Other",
};

export type DialogTypeValue = "FRB" | "FFR" | "Other";

export const DialogOtherGamesMessage = {
    FRB: "FRB",
    FFR: "FFR",
    MIXED: "MIXED",
};

export type DialogOtherGamesMessageValue = "FRB" | "FFR" | "MIXED";



/** WEBPACK FOOTER **
 ** ./Engine/Game/Channels/Common/Dialogs/FreeRoundBonusDialog.ts
 **/